const isDev = process.env.NODE_ENV !== "production";

/* eslint-disable no-console */
export const logError = (...args) => {
  if (isDev) console.error(...args);
};

export const logWarn = (...args) => {
  if (isDev) console.warn(...args);
};
